export const FEATURE_NAME = '@vshosting/cdn/features/access-log-dialog';
